import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { InstallationsStore } from '@store';

import { AggregatedStatus, InstallationItemGatewayDevice } from '../../../../../projects/client';
import { EventNames } from '../../../../shared/directives/prevent-event/event-names';
import { matTooltipSetter } from '../../../../shared/functions/mat-tooltip-setter/mat-tooltip-setter';
import { BrandLogo } from 'src/app/+installations/helpers/brand-logo';

@Component({
  selector: 'app-main-devices-tile',
  templateUrl: './main-devices-tile.component.html',
  styleUrls: ['./main-devices-tile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainDeviceTileComponent implements OnInit {
  @ViewChildren(MatTooltip)
  set matTooltip(queryList: QueryList<MatTooltip>) {
    matTooltipSetter(queryList);
  }

  @Input() installationId: number;
  @Input() device: InstallationItemGatewayDevice;
  @Input() isDragging: boolean;
  readonly aggregatedStatus = AggregatedStatus;

  isStandaloneGateway: boolean;
  eventNames = EventNames;
  gatewayDirectLink: string;
  lastStatusChangedAt: string;

  private ngUnsubscribe$: Subject<void> = new Subject<void>();
  brandLogo: string;

  constructor(public installationsStore: InstallationsStore, private translate: TranslateService) {}

  ngOnInit(): void {
    this.installationsStore
      .isStandaloneGateway(this.device.gatewaySerial)
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((isStandaloneGateway) => {
        this.isStandaloneGateway = isStandaloneGateway;
      });

    this.installationsStore
      .selectLastStatusChangedAt(this.device.gatewaySerial)
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((lastStatusChangedAt) => {
        this.lastStatusChangedAt = lastStatusChangedAt;
      });
    const deviceRoles = this.device.roles;
    this.brandLogo = BrandLogo.getBrandLogo(deviceRoles);
  }

  getImageUri(): string {
    if (this.isStandaloneGateway) {
      return '/assets/img/devices/standalone.png';
    }

    return this.device?.imageUrl || '/assets/img/devices/device_big.png';
  }

  getTooltip(): string {
    return this.lastStatusChangedAt ? `${this.getTranslation()}: ${this.lastStatusChangedAt}` : '';
  }

  private getTranslation(): string {
    return this.translate.instant('+INSTALLATIONS.INSTALLATION.LAST_STATUS_CHANGED');
  }
}
